/** Toggle an id's membership in a view-exclusion array (pure; order preserved). */
export function toggleExcluded(ids: string[], id: string): string[] {
  return ids.includes(id) ? ids.filter((x) => x !== id) : [...ids, id];
}
